import React from 'react'
import PropTypes from 'prop-types'

export default function Thanking({ backToOffer }) {
  return (
    <div className='title thanks__content'>
      <h2>Thank you for sending your application!</h2>
      <p>Your CV has been successfully received</p>
      {backToOffer && (
        <div className='thanks__button'>
          <button
            className='flex-container align-middle button button--reverse button--medium'
            onClick={backToOffer}
          >
            <span className='button__decor button__decor--reverse button__decor--medium'>
              <svg
                width='96'
                height='96'
                viewBox='0 0 96 96'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle
                  cx='52.421'
                  cy='42.3158'
                  r='40.5526'
                  stroke='#BD9973'
                ></circle>
                <circle
                  opacity='0.4'
                  cx='58.1052'
                  cy='48'
                  r='34.8684'
                  stroke='#838489'
                ></circle>
                <circle
                  opacity='0.2'
                  cx='48'
                  cy='48'
                  r='47.5'
                  stroke='#B3B4B8'
                ></circle>
              </svg>
            </span>
            <span>Back to offer</span>
          </button>
        </div>
      )}
    </div>
  )
}

Thanking.propTypes = {
  backToOffer: PropTypes.func.isRequired,
}
